export enum TradingAccountTypesEnum {
    All,
    Trading,
    Cash
}
